var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbuseLegitimateService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1746 24.5157L26.4203 23.6532L26.5254 22.5124L25.4093 22.2589L24.825 21.2695L23.7738 21.7209L22.7227 21.2695L22.1384 22.2558L21.0223 22.5062L21.1274 23.6501L20.373 24.5157L21.1274 25.3783L21.0223 26.5222L22.1384 26.7757L22.7227 27.762L23.7738 27.3075L24.825 27.7589L25.4093 26.7726L26.5254 26.5191L26.4203 25.3783L27.1746 24.5157ZM22.9638 25.7555L22.228 25.0135C22.1075 24.8929 22.1075 24.6982 22.228 24.5776L22.2497 24.5559C22.3702 24.4354 22.5681 24.4354 22.6887 24.5559L23.1864 25.0568L24.7786 23.4615C24.8992 23.3409 25.0971 23.3409 25.2176 23.4615L25.2393 23.4831C25.3599 23.6037 25.3599 23.7985 25.2393 23.9191L23.409 25.7555C23.2823 25.8761 23.0875 25.8761 22.9638 25.7555Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.288 16.1572H16.2594C15.2168 16.1572 14.3809 17.0026 14.3809 18.0358V29.3072C14.3809 30.3404 15.2168 31.1858 16.2594 31.1858H31.288C32.3212 31.1858 33.1666 30.3404 33.1666 29.3072V18.0358C33.1666 17.0026 32.3306 16.1572 31.288 16.1572ZM31.288 29.3072H16.2594V19.9144H31.288V29.3072Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7868 28.843C36.7868 31.1442 34.9213 33.0097 32.6201 33.0097C30.3189 33.0097 28.4535 31.1442 28.4535 28.843C28.4535 26.5418 30.3189 24.6764 32.6201 24.6764C34.9213 24.6764 36.7868 26.5418 36.7868 28.843Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6201 23.843C29.8601 23.843 27.6201 26.083 27.6201 28.843C27.6201 31.603 29.8601 33.843 32.6201 33.843C35.3801 33.843 37.6201 31.603 37.6201 28.843C37.6201 26.083 35.3801 23.843 32.6201 23.843ZM32.6201 32.843C30.4151 32.843 28.6201 31.048 28.6201 28.843C28.6201 26.638 30.4151 24.843 32.6201 24.843C34.8251 24.843 36.6201 26.638 36.6201 28.843C36.6201 31.048 34.8251 32.843 32.6201 32.843Z",
    fill: "#141414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5957 26.3354V29.1887",
    stroke: "#141414",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.596,
    cy: 31.1859,
    r: 0.570647,
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbuseLegitimateService);
export default __webpack_public_path__ + "static/media/abuse_legitimate_service.3bad032b84c22c3d520332cb026f7a34.svg";
export { ForwardRef as ReactComponent };